
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"79","height":"80"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1691","transform":"translate(.475 .488)"}},[_c('ellipse',{attrs:{"data-name":"Ellipse 312","cx":"39.5","cy":"40","rx":"39.5","ry":"40","transform":"translate(-.475 -.488)","fill":"#4cb953"}}),_c('path',{attrs:{"data-name":"Path 1451","d":"M24.826 38.691L36.07 53.145l21.721-27.92","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"8"}})])])
          )
        }
      }
    